import { useAppDispatch, useAppSelector } from 'appState/store'
import { updateCurrentBatch } from 'features/autocheck/autoCheckSlice'
import { BatchTabType } from 'features/autocheck/types'
import moment from 'moment'
import { useState } from 'react'
import { FaUndo } from 'react-icons/fa'
import { Button } from '@outbound-ai/ursa'
import styled from 'styled-components'

export const AutoCheckRefresh = () => {
  const dispatch = useAppDispatch()
  const { root } = useAppSelector((state) => state.batch)
  const [time, setTime] = useState(
    moment(new Date()).format('MM/DD/YYYY') + ' at ' + moment(new Date()).format('hh:mm:ss A'),
  )
  const refreshTabs = () => {
    setTime(moment(new Date()).format('MM/DD/YYYY') + ' at ' + moment(new Date()).format('hh:mm:ss A'))
    dispatch(
      updateCurrentBatch({
        root: root,
        refresh: true,
      }),
    )
  }
  return (
    <Div>
      {root != BatchTabType.EOBReview && (
        <>
          <span>System status as of {time}</span>
          <Button type="button" variant="tertiary" radius="normal" size="small" onClick={() => refreshTabs()}>
            <FaUndo /> Refresh
          </Button>
        </>
      )}
    </Div>
  )
}

const Div = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  float: right;
  span {
    font-family: ${({ theme }) => theme.fontFamily.milliard};
    ${({ theme }) => theme.typography.s.normal};
    margin-top: 0.5rem;
    margin-left: 1.25rem;
  }
`
